import { CreateAxiosInstance } from '@eta/components';
import { IProviderManagementPublicClient, ProviderManagementPublicClient } from './proxy';
import { authService } from '../../Security/Security';
import { EnsureNotSlashAtEnd } from '../../helpers/UIHelpers';
import { ITaxpayerManagementPublicClient, TaxpayerManagementPublicClient } from './TaxpayerProxy';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const publicPortalUrl = EnsureNotSlashAtEnd((window as any).REACT_APP_PublicGatewayApiBaseURL);

export class ServiceCreator {
    public static getProviderManagementPublicClient(
        anonymousCall = false): IProviderManagementPublicClient {
        return new ProviderManagementPublicClient({
            authService,
            apiGatewayUrl: publicPortalUrl, 
            apiVersion: 1,
            enableAnonymousCall: anonymousCall,
        },undefined, CreateAxiosInstance(true));
    }

    public static getTaxpayerManagementPublicClient(): ITaxpayerManagementPublicClient {
        return new TaxpayerManagementPublicClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1
        },undefined, CreateAxiosInstance(true));
    }
}
